// extracted by mini-css-extract-plugin
export var drawerContent = "_37-0";
export var valueBlock = "_37-1";
export var valueBlockFrom = "_37-2 _37-1";
export var valueBlockTo = "_37-3 _37-1";